import React from 'react'
import TaskGroupsContainer from './TaskGroupsContainer'

const TaskGroups = () => {
  return <TaskGroupsContainer />
}
export default TaskGroups
